import React, {  useState,  useEffect,  useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";
import SearchSelect from "../../../../components/private/searchselect";
import Pagination from "../../../../components/private/pagination";


const ModificacionesContrato = () => {

  const navigate = useNavigate();
  const { authFetch } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [programOptions, setProgramOptions] = useState([]);

  // =========================
  // FILTROS
  // =========================

  const [filtroPrograma, setFiltroPrograma] = useState("");
  const [filtroContratante, setFiltroContratante] = useState("");
  const [filtroAnio, setFiltroAnio] = useState("");
  const [filtroMes, setFiltroMes] = useState("");

  // =========================
  // PAGINACIÓN
  // =========================

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // =========================
  // CARGAR DATOS
  // =========================

  useEffect(() => {

    const loadModificaciones = async () => {

      setLoading(true);

      try {

        const res = await authFetch(
          ENDPOINTS.get_modificaciones_contrato_all
        );

        if (res.success) {

          const rows = res.data || [];

          setData(rows);

          const uniquePrograms = [

            ...new Map(

              rows.map((item) => [

                item.program_id,

                {
                  value: item.program_id,
                  label:
                    `${item.program_name} - ${item.area_name}`
                }

              ])

            ).values()

          ];

          setProgramOptions(uniquePrograms);

        } else {

          setData([]);

          setProgramOptions([]);

        }

      } catch (error) {

        console.error(error);

        setData([]);

        setProgramOptions([]);

      }

      setLoading(false);

    };

    loadModificaciones();

  }, [authFetch]);

    const filteredData = data.filter((item) => {

    const matchesPrograma =

      filtroPrograma === "" ||

      String(item.program_id) ===
      String(filtroPrograma);

    const matchesContratante =

      filtroContratante === "" ||

      item.contratante
        ?.toLowerCase()
        .includes(
          filtroContratante.toLowerCase()
        );

    const matchesAnio =

      filtroAnio === "" ||

      new Date(item.created_at)
        .getFullYear()
        .toString()
        .includes(filtroAnio);

    const matchesMes =

      filtroMes === "" ||

      String(
        new Date(item.created_at)
          .getMonth() + 1
      ) === String(filtroMes);

    return (

      matchesPrograma &&
      matchesContratante &&
      matchesAnio &&
      matchesMes

    );

  });

    const totalPages = Math.ceil(
    filteredData.length / recordsPerPage
  );

  const currentData = filteredData.slice(

    (currentPage - 1) * recordsPerPage,

    currentPage * recordsPerPage

  );

  const goToPage = (page) => {

    if (
      page >= 1 &&
      page <= totalPages
    ) {

      setCurrentPage(page);

    }

  };

    if (loading) {

    return (

      <div className="text-center mt-4">

        Cargando...

      </div>

    );

  }

    return (

    <div className="container mt-4 p-4">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center mb-4">

        <h3>
          Modificaciones Contractuales
        </h3>

        <button
          className="btn btn-outline-pink"
          onClick={() =>
            navigate(
              "/session/mod_administrativa/informacion_general/informacion_general"
            )
          }
        >

          <i className="bi bi-arrow-left me-1"></i>

          Volver

        </button>

      </div>

      {/* FILTROS */}

      <div className="row mb-4">

        <div className="col-md-3">

          <label className="m-1">
            Programa
          </label>

          <SearchSelect
            options={[
              {
                value: "",
                label: "Todos"
              },
              ...programOptions
            ]}
            value={filtroPrograma}
            onChange={(val) => {

              setFiltroPrograma(val);

              setCurrentPage(1);

            }}
            placeholder="Buscar programa..."
          />

        </div>

        <div className="col-md-3">

          <label className="m-1">
            Contratante
          </label>

          <input
            type="text"
            className="form-control"
            value={filtroContratante}
            onChange={(e) => {

              setFiltroContratante(
                e.target.value
              );

              setCurrentPage(1);

            }}
          />

        </div>

        <div className="col-md-3">

          <label className="m-1">
            Año
          </label>

          <input
            type="text"
            className="form-control"
            maxLength={4}
            value={filtroAnio}
            onChange={(e) => {

              setFiltroAnio(
                e.target.value
              );

              setCurrentPage(1);

            }}
          />

        </div>

        <div className="col-md-3">

          <label className="m-1">
            Mes
          </label>

          <select
            className="form-select"
            value={filtroMes}
            onChange={(e) => {

              setFiltroMes(
                e.target.value
              );

              setCurrentPage(1);

            }}
          >

            <option value="">
              Todos
            </option>

            <option value="1">Enero</option>
            <option value="2">Febrero</option>
            <option value="3">Marzo</option>
            <option value="4">Abril</option>
            <option value="5">Mayo</option>
            <option value="6">Junio</option>
            <option value="7">Julio</option>
            <option value="8">Agosto</option>
            <option value="9">Septiembre</option>
            <option value="10">Octubre</option>
            <option value="11">Noviembre</option>
            <option value="12">Diciembre</option>

          </select>

        </div>

      </div>

      {/* TABLA */}

      <div className="table-responsive">

        <table className="table table-bordered table-hover">

          <thead className="table-secondary">

            <tr>

              <th>Programa</th>
              <th>Área</th>
              <th>Contratante</th>
              <th>Contrato</th>
              <th>Cobertura</th>
              <th>Fecha Registro</th>

            </tr>

          </thead>

          <tbody>

            {currentData.length > 0 ? (

              currentData.map((item) => (

                <tr key={item.id}>

                  <td>{item.program_name}</td>

                  <td>{item.area_name}</td>

                  <td>{item.contratante}</td>

                  <td>{item.contrato_convenio}</td>

                  <td>
                    {item.cobertura_contratada || ""}
                  </td>

                  <td>

                    {
                      new Date(
                        item.created_at
                      ).toLocaleString(
                        "es-CO",
                        {
                          day: "numeric",
                          month: "long",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true
                        }
                      )
                    }

                  </td>

                </tr>

              ))

            ) : (

              <tr>

                <td
                  colSpan="6"
                  className="text-center"
                >

                  No existen modificaciones registradas

                </td>

              </tr>

            )}

          </tbody>

        </table>

      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={goToPage}
      />

    </div>

  );

};

export default ModificacionesContrato;